package demos.animatedContent

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.SizeTransform
import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.layout.Row
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.BlurredEdgeTreatment
import androidx.compose.ui.draw.blur
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.delay
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime


const val BLURRED_NUMBER_CHANGE = "aa56eb7a5a5d4119451ea03a5981233fd1696d3ce37fd5e1fc8d30fc37bbbbca"


val textColor = Color(0xfff08275)

@Composable
fun BlurredTimeAnimation() {
    var time by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        while (true) {
            time = currentTime()
            delay(1000)
        }
    }

    BlurredAnimatedTextContent(time)
}

@Composable
fun BlurredAnimatedTextContent(text: String) {
    Row {
        val chars = text.split("")
        chars.forEachIndexed { index, digit ->
            AnimatedContent(
                targetState = digit,
                transitionSpec = {
                    scaleIn(
                        initialScale = .5f,
                        animationSpec = spring(stiffness = Spring.StiffnessLow)
                    ) + slideInVertically(
                        spring(
                            dampingRatio = Spring.DampingRatioMediumBouncy,
                            stiffness = Spring.StiffnessLow - (30f * (chars.lastIndex - index)),
                        )
                    ) { -it } togetherWith
                            scaleOut(targetScale = .5f) + slideOutVertically { it } using
                            SizeTransform(
                                clip = false,
                                sizeAnimationSpec = { _, _ ->
                                    spring(
                                        dampingRatio = Spring.DampingRatioMediumBouncy,
                                        stiffness = Spring.StiffnessLow,
                                    )
                                }
                            )
                }
            ) { animatedDigit ->

                var shouldBlur by remember { mutableStateOf(true) }
                LaunchedEffect(Unit) { shouldBlur = false }
                val blur by animateDpAsState(
                    targetValue = if (shouldBlur) 20.dp else 0.dp,
                    animationSpec = spring(stiffness = Spring.StiffnessLow)
                )

                LaunchedEffect(digit) {
                    if (!shouldBlur && digit != animatedDigit) shouldBlur = true
                }

                val color by animateColorAsState(
                    targetValue = if (shouldBlur) textColor.copy(alpha = 0f) else textColor,
                    animationSpec = spring(stiffness = Spring.StiffnessMedium)
                )

                Text(
                    animatedDigit,
                    modifier = Modifier.blur(
                        radius = blur,
                        edgeTreatment = BlurredEdgeTreatment.Unbounded
                    ),
                    fontWeight = FontWeight.Bold,
                    fontSize = 56.sp,
                    color = color,
                )
            }
        }
    }
}

private fun currentTime(): String {
    val localTime = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
    return "${
        localTime.hour.toString().padStart(2, '0')
    }:${
        localTime.minute.toString().padStart(2, '0')
    }:${
        localTime.second.toString().padStart(2, '0')
    }"
}